import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/tema4/T4_paneles_billetes_quiz2.glb";
// import { GUI } from "dat.gui";
import gsap from "gsap";

export class PanelesBilletesQuizTwo extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.position.set(-10.9854, -0.912, -1.06);
		this.rotation.set(1.588, -2, -4.7);
		this.scale.set(1.2, 1.2, 1)
		// this.helpers()

	}
	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.OptionA = gltf.scene.getObjectByName("Option_a", true);
			this.OptionB = gltf.scene.getObjectByName("Option_b", true);
			this.OptionC = gltf.scene.getObjectByName("Option_c", true);
		})
	}
	onElevate(object) {
		this.clearAnimation(object)
		if (!object) {
			return
		}
		this.objectActiveAnimation = object
		object.animation = gsap.to(object.position, {
			y: 0.1,
			duration: 1,
			ease: "power3.out",
		});
	}
	onDrop(object) {
		this.clearAnimation(object)
		if (!object) {
			return
		}
		this.objectActiveAnimation = object
		object.animation = gsap.to(object.position, {
			y: 0,
			duration: 1,
			ease: "power3.out",
		});
	}
	clearAnimation(object) {
		if (object.animation) {
			object.animation.kill();
		}

		if (this.objectActiveAnimation) {
			this.objectActiveAnimation = null
		}
	}
}